<!--
  @component ReleasesScreen — the project's deploy workbench.
  tier:      screen (per-project — `/projects/:id/deployments`)
  mounts:    TriggerIO + PreviewPlanIO + GatesIO + CutoverIO +
             ReleaseIO + RollbackIO + EphemeralIO + DeployRunEdge +
             ReleaseLifecycleEdge (on top of the common chain that
             ConsumerRoot already provides — Topology/Binding/
             Credentials/Observability/Provenance/Lifecycle/Approvals
             + LiveTimelineEdge + TopologyTruthEdge).

  Why mount here rather than in ConsumerRoot:
    These portals + edges hold per-project state machines
    (DeployRunEdge.stage, ReleaseLifecycleEdge.phase, RollbackIO
    inFlight, …). Mounting them at the screen level means leaving
    the deployments screen resets them — the right behavior when
    the operator switches between projects through the URL.
-->
<script lang="ts">
  // Common-chain portals are already mounted by ConsumerRoot. Mount
  // the deploy-specific portals as the inner chain.
  import TriggerIO from "../../../../global/io/nodes/deployment/TriggerIO.svelte";
  import PreviewPlanIO from "../../../../global/io/nodes/deployment/PreviewPlanIO.svelte";
  import GatesIO from "../../../../global/io/nodes/deployment/GatesIO.svelte";
  import CutoverIO from "../../../../global/io/nodes/deployment/CutoverIO.svelte";
  import ReleaseIO from "../../../../global/io/nodes/deployment/ReleaseIO.svelte";
  import RollbackIO from "../../../../global/io/nodes/deployment/RollbackIO.svelte";
  import EphemeralIO from "../../../../global/io/nodes/deployment/EphemeralIO.svelte";
  import DeployRunEdge from "../../../../global/io/edges/deployment/DeployRunEdge.svelte";
  import ReleaseLifecycleEdge from "../../../../global/io/edges/deployment/ReleaseLifecycleEdge.svelte";

  import ReleasesPanel from "./ReleasesPanel.svelte";
</script>

<TriggerIO>
  {#snippet children()}
    <PreviewPlanIO>
      {#snippet children()}
        <GatesIO>
          {#snippet children()}
            <CutoverIO>
              {#snippet children()}
                <ReleaseIO>
                  {#snippet children()}
                    <RollbackIO>
                      {#snippet children()}
                        <EphemeralIO>
                          {#snippet children()}
                            <DeployRunEdge>
                              {#snippet children()}
                                <ReleaseLifecycleEdge>
                                  {#snippet children()}
                                    <ReleasesPanel />
                                  {/snippet}
                                </ReleaseLifecycleEdge>
                              {/snippet}
                            </DeployRunEdge>
                          {/snippet}
                        </EphemeralIO>
                      {/snippet}
                    </RollbackIO>
                  {/snippet}
                </ReleaseIO>
              {/snippet}
            </CutoverIO>
          {/snippet}
        </GatesIO>
      {/snippet}
    </PreviewPlanIO>
  {/snippet}
</TriggerIO>
